import React, {useEffect, useMemo, useState} from 'react';
import PieChart from '../../charts/PieChart'
import BlockChart from "../../BlockChart";
import {useTranslation} from "react-i18next";

const ConsentRequestByLangChart = ( {data = [], isSuccess, isFetching: isLoading, refetch} ) => {
  const { t } = useTranslation();
  const formatData = (data) => (
    data.map(el => (
      {
        y: el.count,
        name: t(`languages.${el.language_code}`)
      }
    ))
  )
  const formattedData = useMemo(() => (formatData(data)), [data])

  return (
    <BlockChart title={t("cmp.analytics.consentRequestsByLang")} isLoading={isLoading} isSuccess={isSuccess}>
      <PieChart data={formattedData}/>
    </BlockChart>
  )
}

export default ConsentRequestByLangChart
